export default "__VITE_ASSET__CFBfVm_2__"